import useGetRepresentatives from './useGetRepresentatives'

export default useGetRepresentatives
